exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueTables__search-field {\n  display: -webkit-flex;\n  display: flex;\n  margin-left: auto;\n}\n.VueTables__search-field input {\n  margin-left: 1em;\n}", ""]);

// exports
